import React from "react";
import { Loader2 } from "lucide-react";

export default function DeleteConfirmationModal({
  onConfirm,
  onCancel,
  isDeleting,
  isDark,
}) {
  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center"
      style={{
        background: isDark
          ? "rgba(13, 13, 13, 0.5)"
          : "rgba(227, 227, 227, 0.5)",
        backdropFilter: "blur(1px)",
        animation: "fadeIn 200ms ease-out both",
      }}
      onClick={onCancel}
    >
      <div
        className={`rounded-2xl ${isDark ? "bg-[#212121]" : "bg-[#FFFFFF]"}`}
        style={{
          width: "512px",
          boxShadow:
            "0 20px 25px -5px rgba(0, 0, 0, 0.10), 0 8px 10px -6px rgba(0, 0, 0, 0.10)",
          transformOrigin: "center",
          animation: "fadeInZoom 200ms ease-out both",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div className="p-24">
          <h2
            className={`font-medium text-[20px] leading-[1.25em] tracking-[-2.25%] ${
              isDark ? "text-[#FFFFFF]" : "text-[#0D0D0D]"
            }`}
          >
            Delete History
          </h2>
        </div>

        {/* Footer */}
        <div className="flex items-center justify-end gap-12 p-24">
          <button
            onClick={onCancel}
            disabled={isDeleting}
            className={`px-16 py-8 rounded-full transition-colors              
              ${
                isDark
                  ? "hover:bg-white-alpha-05 active:bg-white-alpha-10"
                  : "hover:bg-black-alpha-05 active:bg-black-alpha-10"
              }
              ${isDeleting ? "opacity-50 cursor-not-allowed" : ""}
            `}
            style={{
              border: isDark
                ? "1px solid rgba(255, 255, 255, 0.15)"
                : "1px solid rgba(13, 13, 13, 0.1)",
            }}
          >
            <span
              className={`font-medium text-[14px] leading-[1.43em] tracking-[-1.29%] ${
                isDark ? "text-[#FFFFFF]" : "text-[#0D0D0D]"
              }`}
            >
              Cancel
            </span>
          </button>
          <button
            onClick={onConfirm}
            disabled={isDeleting}
            className={`px-16 py-8 rounded-full transition-colors bg-[#E02E2A] flex items-center justify-center gap-2
              ${
                isDark
                  ? "hover:bg-[#E02E2A]/90 active:bg-[#E02E2A]/80"
                  : "hover:bg-[#E02E2A]/80 active:bg-[#E02E2A]/90"
              }
              ${isDeleting ? "opacity-75 cursor-not-allowed" : ""}
            `}
          >
            {isDeleting && (
              <Loader2 className="w-[16px] h-[16px] text-white animate-spin" />
            )}
            <span
              className={`font-medium text-[14px] leading-[1.43em] tracking-[-1.29%] text-[#FFFFFF]`}
            >
              {isDeleting ? "Deleting..." : "Yes, Delete"}
            </span>
          </button>
        </div>
      </div>
    </div>
  );
}
